
import GSpacer from './goose/g-spacer';
import GTrialCtaFooter from './goose/g-trial-cta-footer';
import GBlogPostTags from './goose/g-blog-post-tags';
import GBlogAuthor from './goose/g-blog-author';
export default {
  name: 'cms-blog-footer',
  components: {
    GBlogAuthor,
    GTrialCtaFooter,
    GSpacer,
    GBlogPostTags,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      default: function () {
        return [];
      },
    },
    region: {
      type: String,
      required: true,
    },
  },
};
